module.exports = __webpack_public_path__ + "img/asia03.ca89a68a.png";